import axios from "axios";
import config from '../constants/config';
import { handleApiError } from "../utils/apiErrorHandler";

const API_URL = config.apiBaseUrl; // your backend URL
const JWT_SECRET_KEY = config.JWT_SECRET_KEY;

const UserService = {

  emergencyDetailUpdate: async (params) => {
    const user = JSON.parse(localStorage.getItem("user") || '{}');
    const authToken = user?.authToken || '';

    try {
      const response = await axios.post(`${API_URL}/user/update_em_details`, params, {
        headers: {
          'Authorization': `${JWT_SECRET_KEY} ${authToken}`
        }
      });
      return response.data;
    } catch (error) {
      handleApiError(error);
    }
  },

  getEmergencyDetail: async (uId) => {
    const user = JSON.parse(localStorage.getItem("user") || '{}');
    const authToken = user?.authToken || '';
    try {
      const response = await axios.post(`${API_URL}/user/get_emergency_detail`, { uId: uId }, {
        headers: {
          'Authorization': `${JWT_SECRET_KEY} ${authToken}`
        }
      });
      return response.data.data;
    } catch (error) {
      handleApiError(error);
    }
  },

  deleteEmergencyDetail: async (UDetNo) => {
    const user = JSON.parse(localStorage.getItem("user") || '{}');
    const authToken = user?.authToken || '';
    try {
      const response = await axios.post(`${API_URL}/user/delete_emergency_detail`, { UDetNo: UDetNo }, {
        headers: {
          'Authorization': `${JWT_SECRET_KEY} ${authToken}`
        }
      });
      return response.data.data;
    } catch (error) {
      handleApiError(error);
    }
  },

  updateProfile: async (params) => {
    try {

      const response = await axios.post(`${API_URL}/user/update_profile`,
        params,
        {
          headers: {
            'Content-Type': 'multipart/form-data'
            // 'Authorization': `${JWT_SECRET_KEY} ${authToken}`
          },
        });

      return response.data;
    } catch (error) {
      handleApiError(error);
    }
  },

  getTravelingUsers: async (params) => {
    const authToken = params.authToken;
    delete params.authToken;

    try {
      const response = await axios.post(`${API_URL}/user/get_traveling_users`, params, {
        headers: {
          'Authorization': `${JWT_SECRET_KEY} ${authToken}`
        }
      });
      return response.data.data;
    } catch (error) {
      handleApiError(error);
    }
  },

  //user current location
  saveLatLng: async (params) => {
    const authToken = params.authToken;
    delete params.authToken;

    try {
      const response = await axios.post(`${API_URL}/user/save_lat_lng`, params, {
        headers: {
          'Authorization': `${JWT_SECRET_KEY} ${authToken}`
        }
      });
      return response.data.data;
    } catch (error) {
      handleApiError(error);
    }
  },

  savePassengerReply: async (params) => {
    const authToken = params.authToken;
    delete params.authToken;

    try {
      const response = await axios.post(`${API_URL}/user/save_passenger_reply`, params, {
        headers: {
          'Authorization': `${JWT_SECRET_KEY} ${authToken}`
        }
      });
      return response.data.data;
    } catch (error) {
      handleApiError(error);
    }
  },

  sendOTP: async (params) => {
    try {
      const response = await axios.post(`${API_URL}/user/send_otp`, params);
      return response.data;
    } catch (error) {
      handleApiError(error);
    }
  },

  verifyOTP: async (params) => {
    try {
      const response = await axios.post(`${API_URL}/user/verify_otp`, params);
      return response.data;

    } catch (error) {
      handleApiError(error);
    }
  },

  verifyLoginOTP: async (params) => {
    try {
      const response = await axios.post(`${API_URL}/user/verify_login_otp`, params);
      const data = await response.data.data;
      if (data.authToken) {
        localStorage.setItem("user", JSON.stringify(data));
      }

      return data;
    } catch (error) {
      handleApiError(error);
    }
  },

  passwordUpdate: async (params) => {
    const user = JSON.parse(localStorage.getItem("user") || '{}');
    const authToken = user?.authToken || '';
    try {
      const response = await axios.post(`${API_URL}/user/password_update`, params, {
        headers: {
          'Authorization': `${JWT_SECRET_KEY} ${authToken}`
        }
      });
      return await response.data;
    } catch (error) {
      handleApiError(error);
    }
  },

  forgotPasswordUpdate: async (params) => {
    try {
      const response = await axios.post(`${API_URL}/user/forgot_password_update`, params);
      return await response.data;
    } catch (error) {
      handleApiError(error);
    }
  },

  checkBookedRide: async (params) => {
    const user = JSON.parse(localStorage.getItem("user") || '{}');
    const authToken = user?.authToken || '';
    try {
      const response = await axios.post(`${API_URL}/user/check_booked_ride`, params, {
        headers: {
          'Authorization': `${JWT_SECRET_KEY} ${authToken}`
        }
      });
      return await response.data;
    } catch (error) {
      handleApiError(error);
    }
  },

  getCurrentRouteDetail: async (ReqNo) => {
    const user = JSON.parse(localStorage.getItem("user") || '{}');
    const authToken = user?.authToken || '';
    try {
      const response = await axios.post(`${API_URL}/user/get_current_route_location`, { ReqNo: ReqNo }, {
        headers: {
          'Authorization': `${JWT_SECRET_KEY} ${authToken}`
        }
      });
      return response.data;
    } catch (error) {
      handleApiError(error);
    }
  },

  saveCurrentLatLng: async (params) => {
    const user = JSON.parse(localStorage.getItem("user") || '{}');
    const authToken = user?.authToken || '';
    try {
      const response = await axios.post(`${API_URL}/user/save_current_LatLng`, params, {
        headers: {
          'Authorization': `${JWT_SECRET_KEY} ${authToken}`
        }
      });
      return response.data;
    } catch (error) {
      handleApiError(error);
    }
  },

  getUserDetail: async (params) => {
    const user = JSON.parse(localStorage.getItem("user") || '{}');
    const authToken = user?.authToken || '';
    try {
      const response = await axios.post(`${API_URL}/user/user_detail`, params, {
        headers: {
          'Authorization': `${JWT_SECRET_KEY} ${authToken}`
        }
      });
      return response.data;
    } catch (error) {
      handleApiError(error);
    }
  },

  passengerCancelToRide: async (params) => {
    const user = JSON.parse(localStorage.getItem("user") || '{}');
    const authToken = user?.authToken || '';
    try {
      const response = await axios.post(`${API_URL}/user/cancel_to_ride`, params, {
        headers: {
          'Authorization': `${JWT_SECRET_KEY} ${authToken}`
        }
      });
      return response.data;
    } catch (error) {
      handleApiError(error);
    }
  },

  savePassengerRating: async (params) => {
    const user = JSON.parse(localStorage.getItem("user") || '{}');
    const authToken = user?.authToken || '';
    try {

      const response = await axios.post(`${API_URL}/user/save_rating`,
        params,
        {
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `${JWT_SECRET_KEY} ${authToken}`
          },
        });

      return response.data;
    } catch (error) {
      handleApiError(error);
    }
  },

}


export default UserService;